"use strict";
import {on, find, findAllIn, findIn, removeAttribute} from "@elements/dom-utils";
import axios from "axios";
import {initInScope} from "@elements/init-modules-in-scope";

let accessoriesInitialized;
let backendUrl = location.protocol + '//' + location.host + '/';
let cartButton, modalNode, numberButtons, proceedToCartButton;

export function init() {
    cartButton = findIn('.js-planner__cart-add', TerracePlanner.element);

    if (cartButton) {
        modalNode = find(cartButton.getAttribute('data-bs-target'));
        on('click', (evt) => cartListener(evt, cartButton), cartButton);
    }
}

/**
 * iterates over all
 */
function getAccessories() {
    let accessories = {};
    let planerAccessories = find('.js-planer__accessories');

    findAllIn('.js-product-number-spinner__input', planerAccessories).map((input) => accessories[input.getAttribute('data-id')] = input.value);

    return accessories;
}

function proceedToCartListener(evt, item) {
    removeAttribute('hidden', findIn('.js-planer__accessories-loading', find('.js-planer__accessories')));

    axios({
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        url: backendUrl + 'r/terraceplanner/cart/add',
        params: {
            accessories: getAccessories()
        },
        responseType: 'json',
        validateStatus: function (status) {
            return status === 308; // Resolve only if the status code is less than 500
        }
    }).then(() => {
        location.href = backendUrl + 'checkout/cart';
    });

}

/**
 * listener to load a modal containing all valid accessories for planks and substructure sets
 * @param event
 */
function cartListener(event) {
    if(!accessoriesInitialized) {
        loadModalContent();
    }
}

/**
 * (re)loads the content for the modalNode
 */
function loadModalContent() {
    axios({
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        url: backendUrl + 'r/terraceplanner/accessories/panel',
        responseType: 'json'
    }).then(({success, data}) => {
        loadModalSuccess(data);
    });
}

/**
 * handles a successful response:
 * sets received markup as the modalNode's innerHTML
 * shows the modal and removes the loading overlay
 * adds listeners to button within the modal
 *
 * @param responseText
 */
function loadModalSuccess(responseText) {
    findIn('.js-accessories-modal__content', modalNode).innerHTML = responseText;
    initInScope(modalNode);

    accessoriesInitialized = true;
    editAccessoriesList();

    proceedToCartButton = find('#proceedToCartButton');
    on('click', (evt) => proceedToCartListener(evt, proceedToCartButton), proceedToCartButton)
}

/**
 * adjusts the accessory list inside the modal to re-use shop templates
 */
function editAccessoriesList () {
    findAllIn('.js-product-number-spinner__input', find('.js-planer__accessories')).map((input) =>  input.value = 0);

    //todo preselected class backend ???
    if (find('.preselected')) {
        findAllIn('.js-product-number-spinner__input', find('.preselected')).map((input) =>  input.disabled = true);
    }
}